import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Logo from "../components/Logo";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-ivory flex flex-col items-center justify-center px-4" data-testid="payment-cancel-page">
      <div className="bg-surface border border-line rounded-2xl p-10 max-w-md w-full text-center shadow-sm">
        <div className="flex justify-center mb-6"><Logo size={44} showText={false} /></div>
        <XCircle className="h-12 w-12 text-mutedink mx-auto mb-4" />
        <h1 className="text-xl font-serif font-semibold text-navy">Payment cancelled</h1>
        <p className="mt-3 text-sm text-mutedink leading-relaxed">No charge was made. Your invoice is still open in your portal whenever you are ready.</p>
        <Button asChild className="mt-8 bg-teal text-white hover:bg-teal-dark rounded-full w-full" data-testid="cancel-back-button">
          <Link to="/portal/payments">Back to my payments</Link>
        </Button>
      </div>
    </div>
  );
}
